// TODO: Refactor all places we get and use currency so this becomes the source of truth
const smartId = require('./smart-id')

const CURRENCIES = {
  NGN: { code: 'NGN', symbol: '₦' },
  KES: { code: 'KES', symbol: 'KSh' },
  USD: { code: 'USD', symbol: '$' },
  RWF: { code: 'RWF', symbol: 'RWF' }
}

// Accepts either the 2-letter code used in user.location.country ('ng') or
// the full country name found on some location docs ('nigeria').
const CURRENCY_BY_COUNTRY = {
  ng: 'NGN',
  ke: 'KES',
  rw: 'RWF',
  us: 'USD',
  nigeria: 'NGN',
  kenya: 'KES',
  rwanda: 'RWF'
}

function getCurrencyForCountry (country) {
  if (!country) return null
  const code = CURRENCY_BY_COUNTRY[String(country).toLowerCase()]
  return code ? CURRENCIES[code] : null
}

// Resolves a currency for a fetched location doc, handling the two shapes
// live in the system:
function getCurrencyForLocation (location) {
  if (!location) return CURRENCIES.NGN
  const fromId = smartId.parse(location._id || '').country
  const fromDoc = location.location && location.location.country
  return getCurrencyForCountry(fromId || fromDoc) || CURRENCIES.NGN
}

module.exports = {
  CURRENCIES,
  CURRENCY_BY_COUNTRY,
  getCurrencyForCountry,
  getCurrencyForLocation
}
